import {
  ClipboardDocumentCheckIcon,
  ShieldCheckIcon,
} from "@heroicons/react/20/solid";

const features = [
  {
    name: "Minor Ailment Prescriptions.",
    description:
      "Our pharmacists can prescribe for common minor ailments, including allergies, skin conditions, and infections, saving you a trip to the doctor.",
    icon: ClipboardDocumentCheckIcon,
  },
  {
    name: "Safe & Trusted Care.",
    description:
      "All prescriptions are provided following provincial regulations, ensuring patient safety and effective treatment.",
    icon: ShieldCheckIcon,
  },
];

export default function PrescribingPharmacist() {
  return (
    <div className="overflow-hidden bg-white py-24">
      <div className="mx-auto max-w-7xl px-6">
        <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
          <div className="lg:pt-4 lg:pr-8">
            <div className="lg:max-w-lg">
              <h2 className="text-base/7 font-semibold text-[#f49988]">
                Suffering from Minor Ailment?
              </h2>
              <p className="mt-2 text-4xl font-semibold tracking-tight text-pretty text-gray-900 sm:text-5xl">
                Our Pharmacists Can Prescribe!
              </p>
              <p className="mt-6 text-lg/8 text-gray-600">
                Our licensed pharmacists can prescribe medications for minor
                ailments, helping you get the care you need without unnecessary
                delays at the doctor's office.
              </p>
              <dl className="mt-10 max-w-xl space-y-8 text-base/7 text-gray-600 lg:max-w-none">
                {features.map((feature) => (
                  <div key={feature.name} className="relative pl-9">
                    <dt className="inline font-semibold text-gray-900">
                      <feature.icon
                        aria-hidden="true"
                        className="absolute top-1 left-1 size-5 text-[#e2c6ae]"
                      />
                      {feature.name}
                    </dt>{" "}
                    <dd className="inline">{feature.description}</dd>
                  </div>
                ))}
              </dl>
              {/* Buttons Section */}
              <div className="mt-10 flex gap-4">
                <a
                  href="/consultation"
                  className="inline-flex items-center rounded-md bg-[#f49988] px-6 py-3 text-base font-semibold text-white shadow-sm hover:bg-[#d17564]"
                >
                  See Minor Ailments
                </a>
                <a
                  href="https://bookmypharmacy.com/9057499990"
                  className="inline-flex items-center rounded-md border border-[#f49988] px-6 py-3 text-base font-semibold text-[#f49988] hover:bg-gray-50"
                >
                  Book Consultation Now
                </a>
              </div>
            </div>
          </div>
          <img
            alt="Pharmacist providing care"
            src="./assets/stockphoto1.jpeg"
            // width={2432}
            // height={1442}
            className="w-[25rem] sm:w-[58rem] max-w-none rounded-xl ring-1 shadow-xl ring-gray-400/10 sm:w-[67rem] md:w-[67rem] md:-ml-4 lg:-ml-4"
          />
        </div>
      </div>
    </div>
  );
}
